'use strict';

exports.__esModule = true;
exports.widgetActions = exports.SET_LATEST_AVAILABILITY_FOUND = exports.SET_NEAREST_AVAILABILITY = exports.LOAD_SPECIALIST_PROFILE = exports.LOAD_AVAILABILITIES = exports.UPDATE_START_DATE = exports.PRACTICE_SELECTED = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PRACTICE_SELECTED = exports.PRACTICE_SELECTED = 'WIDGET_ACTIONS:PRACTICE_SELECTED';
var UPDATE_START_DATE = exports.UPDATE_START_DATE = 'WIDGET_ACTIONS:UPDATE_START_DATE';
var LOAD_AVAILABILITIES = exports.LOAD_AVAILABILITIES = 'WIDGET_ACTIONS:LOAD_AVAILABILITIES';
var LOAD_SPECIALIST_PROFILE = exports.LOAD_SPECIALIST_PROFILE = 'WIDGET_ACTIONS:LOAD_SPECIALIST_PROFILE';
var SET_NEAREST_AVAILABILITY = exports.SET_NEAREST_AVAILABILITY = 'WIDGET_ACTIONS:SET_NEAREST_AVAILABILITY';
var SET_LATEST_AVAILABILITY_FOUND = exports.SET_LATEST_AVAILABILITY_FOUND = 'WIDGET_ACTIONS:SET_LATEST_AVAILABILITY_FOUND';

var widgetActions = exports.widgetActions = {
	loadSpecialistProfile: function loadSpecialistProfile(specialistId, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'specialists/' + specialistId,
			method: 'GET',
			actionType: LOAD_SPECIALIST_PROFILE,
			xhrConfig: xhrConfig
		});
	},
	loadAvailabilities: function loadAvailabilities(specialistId, parameters, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			method: 'GET',
			url: 'specialists/' + specialistId + '/availability',
			actionType: LOAD_AVAILABILITIES,
			parameters: (0, _extends3.default)({}, parameters, {
				group_by_date: true
			}),
			xhrConfig: xhrConfig
		});
	},
	onPracticeSelected: function onPracticeSelected(practice) {
		return {
			type: PRACTICE_SELECTED,
			practice: practice
		};
	},
	updateStartDate: function updateStartDate(startDate) {
		return {
			type: UPDATE_START_DATE,
			startDate: startDate
		};
	},
	setLatestAvailabilityFound: function setLatestAvailabilityFound(date) {
		return {
			type: SET_LATEST_AVAILABILITY_FOUND,
			date: date
		};
	},
	setNearestAvailability: function setNearestAvailability(date) {
		return {
			type: SET_NEAREST_AVAILABILITY,
			date: date
		};
	}
};